import { Ellipsis, UserRoundX } from 'lucide-react'

import { useUserContext } from '@/providers/user/useUserContext'
import { Dropdown, DropdownButton, DropdownItem, DropdownMenu } from '@/ui-components/Dropdown'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui-components/Table'

import type { ConnectedAccountUser } from './types'

type ActiveConnectedAccountUsersTableProps = {
  users: ConnectedAccountUser[]
  openRemoveUserFromConnectedAccountsModal: (user: ConnectedAccountUser) => void
}

export const ActiveConnectedAccountUsersTable = ({
  users,
  openRemoveUserFromConnectedAccountsModal,
}: ActiveConnectedAccountUsersTableProps) => {
  const { user } = useUserContext()

  return (
    <Table className="w-[calc(100vw-3rem)] md:w-auto">
      <TableHead>
        <TableRow>
          <TableHeader>Name</TableHeader>
          <TableHeader>Email</TableHeader>
          <TableHeader>Role</TableHeader>
          <TableHeader>Actions</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {users.map((u: ConnectedAccountUser) => (
          <TableRow key={u.id}>
            <TableCell>{u.name}</TableCell>
            <TableCell>{u.email}</TableCell>
            <TableCell className="capitalize">{u.role}</TableCell>
            <TableCell>
              {user?.id !== u.id && (
                <div className="relative z-10 pointer-events-auto">
                  <Dropdown>
                    <DropdownButton plain>
                      <Ellipsis className="size-4" />
                    </DropdownButton>
                    <DropdownMenu anchor="bottom end">
                      <DropdownItem onClick={() => openRemoveUserFromConnectedAccountsModal(u)}>
                        <UserRoundX data-slot="icon" />
                        Remove from Vessel
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
